import React from 'react';
import './Services.css';

// Import service icons
import bracesIcon from '../assets/services/braces.png';
import invisalignIcon from '../assets/services/invisalign.png';
import surgicalIcon from '../assets/services/surgical-orthodontics.png';
import multidisciplinaryIcon from '../assets/services/multidisciplinary-treatment.png';
import twoPhaseIcon from '../assets/services/two-phase-treatment.png';
import retainerIcon from '../assets/services/retainer-fabrication.png';
import preImplantIcon from '../assets/services/pre-implant-positioning.png';
import cosmeticIcon from '../assets/services/cosmetic-contouring.png';
import spaceMaintenanceIcon from '../assets/services/space-maintenance.png';

// Import technology icons
import digitalIcon from '../assets/services/digital.png';
import orthocadIcon from '../assets/services/orthocad.png';
import modernIcon from '../assets/services/modern.png';

const Services: React.FC = () => {
  const services = [
    {
      title: 'Braces for Children & Adults',
      description: 'Traditional metal braces and modern ceramic options for patients of all ages, providing effective treatment with proven results.',
      icon: bracesIcon
    },
    {
      title: 'Invisalign for Teens & Adults',
      description: 'Clear, removable aligners that straighten teeth discreetly. Perfect for busy lifestyles and professional environments.',
      icon: invisalignIcon
    },
    {
      title: 'Surgical Orthodontics',
      description: 'Comprehensive treatment combining orthodontics with oral surgery for complex cases requiring jaw repositioning.',
      icon: surgicalIcon
    },
    {
      title: 'Multi-disciplinary Treatment',
      description: 'Coordinated care with other dental specialists to achieve optimal results for complex treatment plans.',
      icon: multidisciplinaryIcon
    },
    {
      title: '2 Phase Treatment',
      description: 'Early intervention treatment for children to guide proper jaw development and create space for permanent teeth.',
      icon: twoPhaseIcon
    },
    {
      title: 'Retainer Fabrication',
      description: 'Custom bonded or removable retainers to maintain your beautiful new smile after active treatment.',
      icon: retainerIcon
    },
    {
      title: 'Pre-Implant Positioning',
      description: 'Precise tooth positioning to create optimal space and alignment for future dental implant placement.',
      icon: preImplantIcon
    },
    {
      title: 'Cosmetic Contouring',
      description: 'Minor tooth reshaping to improve the appearance and harmony of your smile after orthodontic treatment.',
      icon: cosmeticIcon
    },
    {
      title: 'Space Maintenance',
      description: 'Specialized appliances to preserve space for permanent teeth eruption in growing children.',
      icon: spaceMaintenanceIcon
    }
  ];

  const technologies = [
    {
      title: 'Digital Impressions',
      description: 'No more gooey impression material! Our intra-oral scanner creates precise digital models for your treatment.',
      icon: digitalIcon
    },
    {
      title: 'Orthocad Partnership',
      description: 'Advanced digital treatment planning technology for more precise and efficient orthodontic care.',
      icon: orthocadIcon
    },
    {
      title: 'Modern Technology',
      description: 'State-of-the-art equipment and techniques ensure comfortable, efficient treatment with superior results.',
      icon: modernIcon
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Comprehensive Orthodontic Services</h2>
          <p className="section-subtitle">
            At San Mateo Orthodontics, we offer a full range of modern orthodontic treatments
            designed to give you the confident, healthy smile you deserve. Our experienced team
            uses the latest technology to provide comfortable, efficient care for patients of all ages.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Technology Section */}
        <div className="technology-section">
          <div className="technology-header">
            <h3 className="technology-title">Advanced Technology</h3>
            <p className="technology-subtitle">
              We invest in the latest orthodontic technology to ensure you receive the most effective and comfortable treatment possible.
            </p>
          </div>
          <div className="technology-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="technology-card">
                <div className="technology-icon">
                  <img src={tech.icon} alt={tech.title} />
                </div>
                <h4 className="tech-title">{tech.title}</h4>
                <p className="tech-description">{tech.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="services-cta">
          <h3 className="cta-title">Ready to Start Your Orthodontic Journey?</h3>
          <p className="cta-subtitle">Complete your new patient registration today and take the first step toward your perfect smile. Our team is ready to create your personalized treatment plan.</p>
          <button
            className="cta-button primary services-cta-button"
            onClick={() => {
              const element = document.getElementById('registration');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            aria-label="Complete your registration"
          >
            Complete Registration Now
          </button>
          <p className="services-cta-note">
            ⚡ Quick 2-minute form • 📞 We'll call you within 24 hours
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services; 